/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  LiteLLMInstance,
  LiteLLMInstance$inboundSchema,
} from "./litellminstance.js";

/**
 * A LiteLLM instance and its newly minted plaintext key. The key is shown only once.
 */
export type LitellmInstanceKeyResult = {
  /**
   * A provisioned LiteLLM integration and its project-bound ingestion credential metadata.
   */
  instance: LiteLLMInstance;
  key: string;
};

/** @internal */
export const LitellmInstanceKeyResult$inboundSchema: z.ZodMiniType<
  LitellmInstanceKeyResult,
  unknown
> = z.object({
  instance: LiteLLMInstance$inboundSchema,
  key: z.string(),
});

export function litellmInstanceKeyResultFromJSON(
  jsonString: string,
): SafeParseResult<LitellmInstanceKeyResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => LitellmInstanceKeyResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LitellmInstanceKeyResult' from JSON`,
  );
}
